import { lineAdapter } from "../adapters/lineAdapater";
import AdsTemplateTable from "../common/AdsTemplateTable";
import CreateLineTemplateView from "./CreateLineTemplateView";

export default function LineTemplateTable() {
  return <AdsTemplateTable adapter={lineAdapter} EditDialog={CreateLineTemplateView} />;
}